import {NavigationStart, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ObjectPageNavigationStack} from '../../object-page-v2/object-page-navigation-stack';

type ReturnLinkHistory = Pick<ObjectPageNavigationStack,
  'addArtifactToHistory' | 'hasPendingArtifactHistory' | 'removeArtifactFromHistory'>;

// The redesigned object page lives at /artifact/:artifactId (with or without
// the /search prefix). The legacy page at /artifact?artifactId=… does not show
// a return link, so it is left out.
const OBJECT_PAGE_PATH = /^\/(search\/)?artifact\/[^/?#]+/;

export function isObjectPageUrl(url: string): boolean {
  return OBJECT_PAGE_PATH.test(url ?? '');
}

/**
 * Opening an object from the procedure (table, cards or metadata links)
 * records the procedure, so the object page offers a way back to it instead
 * of the search navigation. Browser back and forward are left alone.
 */
export function watchProcedureReturnLink(
  router: Router,
  history: ReturnLinkHistory,
  procedureName: () => string | undefined,
): Subscription {
  return router.events.subscribe(event => {
    if (!(event instanceof NavigationStart) || event.navigationTrigger === 'popstate' || !isObjectPageUrl(event.url)) {
      return;
    }
    const name = procedureName();
    if (!name) {
      return;
    }
    // A metadata link (app-object-url) may already have recorded this page,
    // but with the target's query parameters; replace it with the procedure's own.
    if (history.hasPendingArtifactHistory) {
      history.removeArtifactFromHistory();
    }
    const currentUrl = router.parseUrl(router.url);
    history.addArtifactToHistory(name, router.url.split(/[?#]/)[0], currentUrl.queryParams);
  });
}
